import { DotsButton, IDotsButtonProps } from "dots-ui/dotsButton";

export function AvisButton(props: Readonly<IDotsButtonProps>) {
  return <DotsButton {...props} />;
}
